export default "__VITE_ASSET__Bh4GfWsz__"